module.exports = "/_next/static/images/cb4fb91ee2573c59819931af86a59a6c-nuconta-inclined-device@2x.png.webp";